export default {
  "content": "<path d=\"M0 0h48v48H0z\" fill=\"none\"/><path d=\"M5 40h38v4H5z\" fill=\"#D7D8DE\"/><path d=\"M45 3.01H3a1 1 0 00-1 1V12a1 1 0 001 1h1v31a1 1 0 001 1h38a1 1 0 001-1V13h1a1 1 0 001-1V4.01a1 1 0 00-1-1zM42 39H6V13h36zM6 43v-2h36v2zm38-32H4V5.01h40z\" fill=\"#3F4450\"/><path d=\"M16 25h16a1 1 0 001-1v-6a1 1 0 00-1-1H16a1 1 0 00-1 1v6a1 1 0 001 1zm1-6h14v4H17z\" fill=\"#3F4450\"/>",
  "attrs": {
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};